import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const EightPointStar = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="84" viewBox="0 0 84 85" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42.399 0.909721L54.5786 13.0902H71.8038V30.3145L83.9834 42.494L71.8038 54.6745V71.8988H54.5786L42.399 84.0793L30.2195 71.8988H12.9942V54.6745L0.814728 42.494L12.9942 30.3145V13.0902H30.2195L42.399 0.909721Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
